import { render, staticRenderFns } from "./CustomerViewNotesTab.vue?vue&type=template&id=035fc98e&scoped=true"
import script from "./CustomerViewNotesTab.vue?vue&type=script&lang=js"
export * from "./CustomerViewNotesTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerViewNotesTab.vue?vue&type=style&index=0&id=035fc98e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035fc98e",
  null
  
)

export default component.exports